import React from 'react';

/**
 * Score Card Component
 * Display category scores with visual bars
 */
const ScoreCard = ({ 
  category, 
  score, 
  maxScore = 100, 
  rating = '', 
  showBar = true 
}) => {
  const percentage = (score / maxScore) * 100;
  
  const getRatingColor = (rating) => {
    const colors = {
      'Excellent': 'text-green-400 bg-green-500/20',
      'Good': 'text-blue-400 bg-blue-500/20',
      'Fair': 'text-yellow-400 bg-yellow-500/20',
      'Needs Work': 'text-red-400 bg-red-500/20',
      'Needs Improvement': 'text-red-400 bg-red-500/20'
    };
    return colors[rating] || 'text-slate-400 bg-slate-700';
  };

  const getBarColor = (percentage) => {
    if (percentage >= 80) return 'bg-green-500';
    if (percentage >= 60) return 'bg-blue-500';
    if (percentage >= 40) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 hover:border-primary-500/50 transition-colors">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-slate-200 font-medium">{category}</h4>
        <div className="flex items-center gap-3">
          <span className="text-2xl font-bold text-slate-100">{score}</span>
          {rating && (
            <span className={`px-2 py-1 rounded text-xs font-semibold ${getRatingColor(rating)}`}>
              {rating}
            </span>
          )}
        </div>
      </div>
      
      {showBar && (
        <div className="w-full bg-slate-700 rounded-full h-2 overflow-hidden">
          <div
            className={`h-full ${getBarColor(percentage)} transition-all duration-1000 ease-out rounded-full`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default ScoreCard;
